// AvailableUsersReducer.js

import * as actionTypes from "../ActionTypes";

const initialState = {
  users: [],
  loading: false,
  requests: [],          
  success: false,
  error: null,
  myCircle: [],          

};

const availableUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AVAILABLE_USERS_REQUEST:
      return { ...state, loading: true, error: null };
      case actionTypes.SAVE_USER_CIRCLE_REQUEST:
        return { ...state, loading: true, error: null, success: false };
        case actionTypes.MY_CIRCLE_REQUESTS_REQUEST:
  return { ...state, loading: true, error: null };
  case actionTypes.UPDATE_USER_CIRCLE_REQUEST:
  return { ...state, loading: true, error: null };
  case actionTypes.MY_CIRCLE_LIST_REQUEST:
  return { ...state, loading: true, error: null };

    case actionTypes.AVAILABLE_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload?.data?.[0]?.matchingUsers || [],
      };

    case actionTypes.SAVE_USER_CIRCLE_SUCCESS:
        return { ...state, loading: false, success: true };

case actionTypes.MY_CIRCLE_REQUESTS_SUCCESS:
    return {
      ...state,
      loading: false,
      requests: action.payload?.data || [],
    };
    case actionTypes.UPDATE_USER_CIRCLE_SUCCESS:
  return { ...state, loading: false, success: true };

  case actionTypes.MY_CIRCLE_LIST_SUCCESS:
    return {
      ...state,
      loading: false,
      myCircle: action.payload?.data || [],
    };

    case actionTypes.AVAILABLE_USERS_FAIL:
      return { ...state, loading: false, error: action.payload };
      case actionTypes.SAVE_USER_CIRCLE_FAIL:
        return { ...state, loading: false, error: action.payload, success: false };
        case actionTypes.MY_CIRCLE_REQUESTS_FAIL:
  return { ...state, loading: false, error: action.payload };

case actionTypes.UPDATE_USER_CIRCLE_FAIL:
    return { ...state, loading: false, error: action.payload, success: false };
    case actionTypes.MY_CIRCLE_LIST_FAIL:
        return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default availableUsersReducer;
